import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing24 } from 'approot/shared/styles/spacing.style';

type ComponentWrapperProps = {
  $marginBottom?: number;
};
export const ComponentViewWrapper = styled.div<ComponentWrapperProps>`
  position: relative;
  margin-bottom: ${({ $marginBottom = spacing24 }) => rem($marginBottom)};
`;
